import { createSelector } from "reselect";

const getIssuerManager = (state) => state.issuerManager;

export const selectIssuerManagerSelectedIssuer = createSelector(
    getIssuerManager,
    (issuerManager) => issuerManager.selectedIssuer
);
export const selectIssuerManagerLoading = createSelector(getIssuerManager, (issuerManager) => issuerManager.isLoading);
export const selectIssuerManagerIssuersList = createSelector(getIssuerManager, (issuerManager) => issuerManager.issuersList);
